<template>
    <button type="button" class="elle-btn" :class="[style]" data-is-btn :title="text" @click="$emit('btn-click')">
        <span class="text">{{ text }}</span>
        <span class="icon">
            <UiSvgArrowLeft />
        </span>
    </button>
</template>

<script setup lang="ts">
defineEmits(['btn-click']);
defineProps({
    style: {
        type: String,
        default: 'black'
    },
    text: {
        type: String,
        default: ''
    }
});
</script>
